export const API_MOCK_ENABLED = import.meta.env.VITE_APP_MOCKED_DATA || false;

export const ROUTES = {
  home: '/',
  panels: '/panels',
  companyPanels: '/panels',
  companies: '/companies',
  createPanel: '/createPanel',
  paymentMethods: '/redemptionMethods',
  createPaymentMethod: '/createRedemptionMethod',
  paymentMethodSettings: (path: string) => `${path}/redemptionMethodsettings`,
  voucherCode: '/voucherCode',
  paymentMethodSettingsv2: (path: string) =>
    `${path}/redemptionMethodsettingsv2`,
  settings: (path: string) => `${path}/settings`,
  branding: (path: string) => `${path}/branding`,
  url: (path: string) => `${path}/url`,
  redemptionMethods: (path: string) => `${path}/panelRedemptionMethods`,
  payout: (path: string) =>
    `${path}/panelRedemptionMethods/:panelPaymentMethodId/redemption`,
  dynamicIncentiveModelSettings: (path: string) =>
    `${path}/dynamicIncentiveSettings`,
  panelistImport: (path: string) => `${path}/panelistImport`,
  createMarketingCampaign: (path: string) => `${path}/createMarketingCampaign`,
  marketingCampaigns: (path: string) => `${path}/marketingCampaigns`,
  referralProgram: (path: string) => `${path}/referralProgram`,
  uploadCodes: (path: string) => `${path}/uploadCodes`,
  leadImport: (path: string) => `${path}/leadImport`,
  manualActivationManagement: (path: string) =>
    `${path}/manualActivationManagement`,
  emailBlocklist: '/emailBlocklist',
  buyerIdBlocklist: '/buyerIdBlocklist',
  panelists: '/panelists',
  bulkBanning: '/bulkBanning',
  bulkBalanceAdjustment: '/bulkBalanceAdjustment',
  unauthorized: '/unauthorized',
  signalTemplates: '/trackingTemplates',
  translations: '/translations',
  translationsBulkUpdate: '/translationsBulkUpdate',
  createTranslation: '/createTranslation',
  createSignalTemplates: '/createTrackingTemplate',
  recruitmentInsights: '/recruitmentInsights',
  panelInsights: '/panelInsights',
  billingInsights: '/billingInsights',
  financialInsights: '/panelInsights/financial',
  surveyInsights: '/panelInsights/survey',
  retentionInsights: '/panelInsights/retention',
  demographicsInsights: '/panelInsights/demographics',
  overviewInsights: '/panelInsights/overview',
  exportPanel: '/exportPanel',
  targetedSampling: '/targetedSampling',
  profiling: '/profiling',
  metaCallback: '/meta/callback',
  googleCallback: '/google/callback',
};

// Auth0 must skip its own redirect handling on these: they carry a code/state
// pair that isn't Auth0's.
export const OAUTH_CALLBACK_ROUTES = [
  ROUTES.metaCallback,
  ROUTES.googleCallback,
];

export const PERMISSIONS_PREFIX = 'eng:';
